module.exports = __webpack_public_path__ + "static/media/businessModal.02ae90e1.jpg";